import Leads from "../../components/Pages/Tracking/Leads/Leads";

const TrackingLeads = () => {
  return (
    <div>
      <Leads />
    </div>
  );
};

export default TrackingLeads;
